module.exports = __webpack_public_path__ + "static/mobile.vp9-d1df27d92dc02517a886350256bd75d7.webm";